/* eslint-disable react/prop-types */
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import * as React from 'react';
import { useNavigate } from "react-router-dom";
import ellipsis from 'utils/ellipsis';
import SoftBadge from "../../components/SoftBadge";
import fixTableCellWidth from "../../utils/fixTableCellWidth";

function createData(id, name, phone, address, description, operation) {
    return {
        id, name, phone, address, description, operation
    };
}

function Row(props) {
    const { row } = props;

    return (
        <React.Fragment>
            <TableRow
                sx={{ '& > *': { borderBottom: 'unset' }, backgroundColor: row.id % 2 === 1 ? "" : "rgba(204,204,204,0.1)" }}>
                <TableCell className="tablecell" align="left" title={row.name}
                    style={fixTableCellWidth("160px")}>{row.name}</TableCell>
                <TableCell className="tablecell" align="left" title={row.phone}
                    style={fixTableCellWidth("160px")}>{row.phone}</TableCell>
                <TableCell className="tablecell" align="left" title={row.address}
                    style={fixTableCellWidth("160px")}>{row.address}</TableCell>
                <TableCell className="tablecell" align="left" title={row.description}
                    style={fixTableCellWidth("160px")}>{ellipsis(row.description, 40)}</TableCell>
                <TableCell className="tablecell" align="left"
                    style={fixTableCellWidth("100px")}>{row.operation}</TableCell>
            </TableRow>
        </React.Fragment>
    );
}

export default function CompanyTable({ data }) {
    const navigate = useNavigate()

    const rows = data.map(item => createData(item.id, item.name, item.phone, item.address, item.description, <section style={{ display: "flex", cursor: 'pointer' }}>
        <SoftBadge variant="contained"
            onClick={() => navigate(`/new-company?method=update`, { state: item })}
            badgeContent="آپدیت"
            color="secondary" size="xs" />
    </section>
    ))

    return (
        <>
            <TableContainer component={Paper}>
                <Table>
                    <TableHead>
                        <SoftBadge onClick={() => navigate("/new-company")} variant="contained"
                            badgeContent="شرکت جدید" color="success" size="xs"
                            container
                            style={{ cursor: 'pointer' }} />
                        <TableRow>
                            <TableCell className="tablecell" style={fixTableCellWidth("150px")}>نام</TableCell>
                            <TableCell className="tablecell" style={fixTableCellWidth("150px")}>موبایل</TableCell>
                            <TableCell className="tablecell" style={fixTableCellWidth("170px")}>آدرس</TableCell>
                            <TableCell className="tablecell" style={fixTableCellWidth("150px")}>توضیحات</TableCell>
                            <TableCell className="tablecell" style={fixTableCellWidth("150px")}>عملیات</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody style={{ display: 'block' }}>
                        {rows.map((row) => (
                            <Row key={row.id} row={row} />
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </>
    );
}
